(function () {
  if (window.__ioosilkPdpMobileFix20260726) return;
  window.__ioosilkPdpMobileFix20260726 = true;

  var GOLD = '#c79818';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }

  function qs(selector, scope) {
    return (scope || document).querySelector(selector);
  }

  function qsa(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  function closest(target, selector) {
    var el = target && target.nodeType === 1 ? target : target && target.parentElement;
    return el && el.closest ? el.closest(selector) : null;
  }

  function norm(value) {
    return String(value == null ? '' : value)
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function money(cents) {
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function variants() {
    var el = qs('#v-json');
    if (!el) return [];
    try {
      var parsed = JSON.parse(el.textContent || el.innerHTML || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      console.warn('IOOSILK variant JSON parse failed', e);
      return [];
    }
  }

  function currentVariantFromInput() {
    var input = qs('#v-id');
    var id = input && input.value;
    if (!id) {
      try { id = new URL(window.location.href).searchParams.get('variant'); } catch (e) {}
    }
    if (!id) return null;
    return variants().find(function (variant) { return String(variant.id) === String(id); }) || null;
  }

  function selectByVariant(variant) {
    if (!variant || !Array.isArray(variant.options)) return;
    qsa('.opt-row').forEach(function (row, index) {
      var wanted = norm(variant.options[index]);
      var found = qsa('.opt-box', row).find(function (box) {
        return norm(box.getAttribute('data-val') || box.textContent) === wanted;
      });
      if (!found) return;
      qsa('.opt-box', row).forEach(function (box) { box.classList.remove('active'); });
      found.classList.add('active');
    });
  }

  function selectedOptions() {
    var rows = qsa('.opt-row');
    return rows.map(function (row) {
      var active = qs('.opt-box.active', row) || qs('.opt-box', row);
      return norm(active && (active.getAttribute('data-val') || active.textContent));
    });
  }

  function findVariant() {
    var selected = selectedOptions();
    var list = variants();
    var exact = list.find(function (variant) {
      return Array.isArray(variant.options) && variant.options.every(function (option, index) {
        return norm(option) === selected[index];
      });
    });
    return exact || currentVariantFromInput() || list[0] || null;
  }

  function styleOptions() {
    qsa('.opt-box').forEach(function (box) {
      var active = box.classList.contains('active');
      box.setAttribute('role', 'button');
      box.setAttribute('tabindex', '0');
      box.setAttribute('aria-pressed', active ? 'true' : 'false');
      box.style.setProperty('opacity', '1', 'important');
      box.style.setProperty('cursor', 'pointer', 'important');
      box.style.setProperty('border-color', active ? GOLD : 'rgba(0,0,0,.15)', 'important');
      box.style.setProperty('box-shadow', active ? '0 0 0 1px rgba(199,152,24,.45) inset' : 'none', 'important');
      box.style.setProperty('color', active ? GOLD : '', 'important');
    });
  }

  function syncVariant() {
    var variant = findVariant();
    if (!variant) return null;
    selectByVariant(variant);
    var input = qs('#v-id');
    if (input) input.value = variant.id;
    var price = money(variant.price);
    var priceEl = qs('#p-price');
    var currentPrice = qs('#current-price');
    if (priceEl) priceEl.textContent = price;
    if (currentPrice) currentPrice.textContent = 'Selected: ' + price;
    if (variant.img_id) {
      qsa('.g-thumb').some(function (thumb, index) {
        if (String(thumb.getAttribute('data-id')) !== String(variant.img_id)) return false;
        switchGallery(index, thumb);
        return true;
      });
    }
    var button = qs('#buy-btn');
    if (button && button.dataset.ioosilkBusy !== 'true') {
      button.disabled = false;
      button.removeAttribute('disabled');
      button.setAttribute('aria-disabled', 'false');
      button.textContent = 'ADD TO CART';
    }
    styleOptions();
    return variant;
  }

  function switchGallery(index, thumb) {
    var gallery = qs('#g-scroll');
    if (!gallery) return;
    var slides = qsa('.g-slide', gallery);
    var safe = Math.max(0, Math.min(slides.length - 1, Number(index) || 0));
    var slide = slides[safe];
    if (!slide) return;
    if (gallery.scrollTo) gallery.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    else gallery.scrollLeft = slide.offsetLeft;
    qsa('.g-thumb').forEach(function (item) { item.classList.remove('active'); });
    (thumb || qsa('.g-thumb')[safe] || {}).classList && (thumb || qsa('.g-thumb')[safe]).classList.add('active');
  }

  function drawer() {
    return qs('#velvet-cart-drawer');
  }

  function backdrop() {
    return qs('#cart-backdrop');
  }

  function forceDrawer(open) {
    var d = drawer();
    var b = backdrop();
    if (d) {
      d.classList.toggle('translate-x-full', !open);
      d.setAttribute('aria-hidden', open ? 'false' : 'true');
      d.style.setProperty('position', 'fixed', 'important');
      d.style.setProperty('top', '0', 'important');
      d.style.setProperty('right', '0', 'important');
      d.style.setProperty('bottom', '0', 'important');
      d.style.setProperty('left', 'auto', 'important');
      d.style.setProperty('width', 'min(440px, 92vw)', 'important');
      d.style.setProperty('height', '100vh', 'important');
      d.style.setProperty('transform', open ? 'translateX(0)' : 'translateX(100%)', 'important');
      d.style.setProperty('visibility', 'visible', 'important');
      d.style.setProperty('display', 'block', 'important');
      d.style.setProperty('z-index', '2147483200', 'important');
    }
    if (b) {
      b.classList.toggle('opacity-0', !open);
      b.classList.toggle('pointer-events-none', !open);
      b.setAttribute('aria-hidden', open ? 'false' : 'true');
      b.style.setProperty('position', 'fixed', 'important');
      b.style.setProperty('inset', '0', 'important');
      b.style.setProperty('z-index', '2147483100', 'important');
      b.style.setProperty('opacity', open ? '1' : '0', 'important');
      b.style.setProperty('pointer-events', open ? 'auto' : 'none', 'important');
      b.style.setProperty('background', 'rgba(0,0,0,.42)', 'important');
    }
    document.body.classList.toggle('velvet-cart-open', open);
  }

  function setCartCount(count) {
    qsa('.cart-count, [data-cart-count]').forEach(function (el) { el.textContent = count; });
  }

  async function getCart() {
    var res = await fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('Cart load failed');
    return res.json();
  }

  async function renderCart() {
    var cart = await getCart();
    setCartCount(cart.item_count || 0);
    var subtotal = qs('#cart-subtotal');
    if (subtotal) subtotal.textContent = money(cart.total_price);
    var wrap = qs('#cart-items-container');
    if (!wrap) return cart;
    if (!cart.item_count) {
      wrap.innerHTML = '<div class="ioosilk-cart-empty">Your selection is empty</div>';
      return cart;
    }
    wrap.innerHTML = cart.items.map(function (item) {
      var img = item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.product_title) + '">' : '';
      return '<div class="ioosilk-cart-item" data-cart-item>' +
        '<div class="ioosilk-cart-item__image">' + img + '</div>' +
        '<div class="ioosilk-cart-item__body"><div><h3 class="ioosilk-cart-item__title">' + escapeHtml(item.product_title) + '</h3>' +
        '<p class="ioosilk-cart-item__variant">' + escapeHtml(item.variant_title || '') + '</p></div>' +
        '<div class="ioosilk-cart-item__controls"><div class="ioosilk-cart-qty">' +
        '<button type="button" data-cart-key="' + escapeHtml(item.key) + '" data-cart-qty="' + (item.quantity - 1) + '">-</button>' +
        '<span data-cart-qty-value>' + item.quantity + '</span>' +
        '<button type="button" data-cart-key="' + escapeHtml(item.key) + '" data-cart-qty="' + (item.quantity + 1) + '">+</button>' +
        '</div><div><span class="ioosilk-cart-item__price">' + money(item.line_price) + '</span>' +
        '<button type="button" class="ioosilk-cart-remove" data-cart-key="' + escapeHtml(item.key) + '" data-cart-qty="0">Remove</button></div></div></div></div>';
    }).join('');
    return cart;
  }

  function openCart() {
    if (!drawer()) {
      window.location.href = '/cart';
      return;
    }
    forceDrawer(true);
    renderCart().catch(function (e) { console.warn('IOOSILK cart refresh failed', e); });
  }

  function closeCart() {
    forceDrawer(false);
  }

  function message(form, text, isError) {
    if (!form) return;
    var el = qs('[data-ioosilk-cart-message]', form);
    if (!el) {
      el = document.createElement('p');
      el.setAttribute('data-ioosilk-cart-message', '');
      el.setAttribute('role', 'status');
      el.style.cssText = 'margin:12px 0 0;font-family:Cinzel,serif;font-size:10px;letter-spacing:.16em;text-transform:uppercase;text-align:center;';
      form.appendChild(el);
    }
    el.style.color = isError ? '#9a1f32' : GOLD;
    el.textContent = text || '';
  }

  async function addToCart(form) {
    form = form || qs('#pdp-add-form');
    if (!form) return;
    var variant = syncVariant();
    var id = variant && variant.id || (qs('#v-id') || {}).value || new FormData(form).get('id');
    var button = qs('#buy-btn');
    if (!id) {
      message(form, 'Please choose an option.', true);
      return;
    }
    if (button) {
      button.dataset.ioosilkBusy = 'true';
      button.disabled = true;
      button.textContent = 'ADDING...';
    }
    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(id), quantity: 1 })
      });
      var data = await res.json().catch(function () { return {}; });
      if (!res.ok) throw new Error(data.description || data.message || 'Add to cart failed.');
      message(form, 'Added to cart.', false);
      if (button) {
        button.classList.add('is-added');
        button.textContent = 'ADDED';
        setTimeout(function () { button.classList.remove('is-added'); button.textContent = 'ADD TO CART'; }, 900);
      }
      openCart();
    } catch (e) {
      message(form, e.message || 'This option could not be added.', true);
      if (button) button.textContent = 'ADD TO CART';
    } finally {
      if (button) {
        button.dataset.ioosilkBusy = 'false';
        button.disabled = false;
        button.removeAttribute('disabled');
        button.setAttribute('aria-disabled', 'false');
      }
    }
  }

  function changeCart(key, quantity, button) {
    var item = closest(button, '[data-cart-item]');
    var oldQty = item && qs('[data-cart-qty-value]', item);
    if (oldQty) oldQty.textContent = String(Math.max(0, quantity));
    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (res) { return res.json(); })
      .then(function (cart) { setCartCount(cart.item_count || 0); return renderCart(); })
      .catch(function () { renderCart().catch(function () {}); });
  }

  function prep() {
    var form = qs('#pdp-add-form');
    if (form) {
      form.removeAttribute('onsubmit');
      form.onsubmit = null;
    }
    qsa('.cart-trigger, .search-cart-v1, .ioosilk-unified-nav__cart').forEach(function (button) {
      button.removeAttribute('onclick');
      button.onclick = null;
      if (button.tagName === 'A') button.setAttribute('href', '#velvet-cart-drawer');
    });
    var existing = currentVariantFromInput() || variants()[0];
    if (existing) selectByVariant(existing);
    syncVariant();
  }

  document.addEventListener('click', function (event) {
    var option = closest(event.target, '.opt-box');
    if (option) {
      event.preventDefault();
      event.stopImmediatePropagation();
      qsa('.opt-box', closest(option, '.opt-row')).forEach(function (box) { box.classList.remove('active'); });
      option.classList.add('active');
      syncVariant();
      return;
    }

    var add = closest(event.target, '#buy-btn');
    if (add) {
      if (window.__ioosilkInlineV2) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      addToCart(qs('#pdp-add-form'));
      return;
    }

    var cart = closest(event.target, '.cart-trigger, .search-cart-v1, .ioosilk-unified-nav__cart, [data-ioosilk-cart-go], a[href="/cart"], a[href^="/cart?"]');
    if (cart && !closest(cart, '#velvet-cart-drawer')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openCart();
      return;
    }

    if (closest(event.target, '[data-cart-close], #cart-backdrop')) {
      event.preventDefault();
      closeCart();
      return;
    }

    var qty = closest(event.target, '[data-cart-key][data-cart-qty]');
    if (qty) {
      event.preventDefault();
      changeCart(qty.getAttribute('data-cart-key'), Number(qty.getAttribute('data-cart-qty')), qty);
      return;
    }

    var thumb = closest(event.target, '.g-thumb');
    if (thumb) {
      event.preventDefault();
      switchGallery(qsa('.g-thumb').indexOf(thumb), thumb);
    }
  }, true);

  document.addEventListener('submit', function (event) {
    if (!event.target || event.target.id !== 'pdp-add-form') return;
    if (window.__ioosilkInlineV2) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    addToCart(event.target);
  }, true);

  document.addEventListener('keydown', function (event) {
    var option = closest(event.target, '.opt-box');
    if (option && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      option.click();
    }
    if (event.key === 'Escape') closeCart();
  });

  window.openCart = openCart;
  window.closeCart = closeCart;
  window.addToCart = function () { addToCart(qs('#pdp-add-form')); };
  window.switchImg = function (index) { switchGallery(index, qsa('.g-thumb')[Number(index) || 0]); };
  window.moveGallery = function (direction) {
    var gallery = qs('#g-scroll');
    if (!gallery) return;
    var index = Math.round(gallery.scrollLeft / Math.max(1, gallery.offsetWidth)) + (Number(direction) || 0);
    switchGallery(index, qsa('.g-thumb')[index]);
  };
  window.selectOption = function (box) {
    if (!box) return;
    qsa('.opt-box', closest(box, '.opt-row')).forEach(function (item) { item.classList.remove('active'); });
    box.classList.add('active');
    syncVariant();
  };

  ready(function () {
    prep();
    renderCart().catch(function () {});
    setTimeout(prep, 350);
    setTimeout(prep, 1200);
  });
})();
